/**
 * @file
 * JavaScript behaviors for page-content component.
 */

(function (Drupal, once) {
  'use strict';

  /**
   * Behavior for sidebar navigation dropdown.
   */
  Drupal.behaviors.sidebarNavDropdown = {
    attach: function (context) {
      const dropdowns = once('sidebar-nav-dropdown', '[data-sidebar-nav-dropdown]', context);

      dropdowns.forEach(dropdown => {
        dropdown.addEventListener('change', function () {
          const url = this.value;
          if (url) {
            window.location.href = url;
          }
        });
      });
    }
  };

})(Drupal, once);
